<template>
  <ComplianceLayout page="about">
    <h1>About Us</h1>
    <p>This website was created to provide simple and accessible information about GB WhatsApp and related messaging app topics.</p>
    <p>Our goal is to help users understand:</p>
    <ul>
      <li>App features</li>
      <li>Version differences</li>
      <li>Installation guides</li>
      <li>Common issues</li>
      <li>General usage information</li>
    </ul>
    <h2>Independent Resource</h2>
    <p>We are not affiliated with:</p>
    <ul>
      <li>WhatsApp Messenger</li>
      <li>Meta Platforms, Inc.</li>
      <li>Official GB WhatsApp developers</li>
    </ul>
    <p>This website operates as an independent informational resource only.</p>
    <h2>Our Mission</h2>
    <p>We aim to create easy-to-read content that helps users make informed decisions when exploring third-party messaging applications.</p>
    <p>We focus on:</p>
    <ul>
      <li>Clear explanations</li>
      <li>Updated information</li>
      <li>Beginner-friendly guides</li>
      <li>Transparent website practices</li>
    </ul>
    <h2>Educational Purpose</h2>
    <p>All content published on this website is intended for informational and educational purposes only.</p>
    <p>Users are responsible for their own software installation and usage decisions.</p>
  </ComplianceLayout>
</template>

<script>
import ComplianceLayout from '@/components/ComplianceLayout.vue';

export default {
  name: 'AboutPage',
  components: {
    ComplianceLayout,
  },
};
</script>
